module.exports = __webpack_public_path__ + "static/media/index_logo.706a756e.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/index_logo.png
// module id = 234
// module chunks = 0